/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getAiQuoteDraft(conversationID) {
    return axios.get(`${this.url}/${conversationID}/ai_quote_draft`);
  }

  generateAiQuoteDraft(conversationID) {
    return axios.post(
      `${this.url}/${conversationID}/ai_quote_draft`,
      {},
      { headers: { 'X-ARMGold-Action': 'ai-quote-draft' } }
    );
  }

  runAiCompetitorCheck(conversationID) {
    return axios.post(
      `${this.url}/${conversationID}/ai_quote_draft/run_competitor_check`
    );
  }
}

export default new ConversationApi();
